import '../../../../front/utils/domPolyfills'

export function importScript (sSrc, fOnload) {
  const oHead = document.head || document.getElementsByTagName('head')[0]
  const oScript = document.createElement('script')

  oScript.type = 'text/javascript'
  oScript.onerror = loadError
  if (fOnload) {
    oScript.onload = fOnload
  }

  oHead.appendChild(oScript)
  oScript.src = sSrc
}

export function loadError (oError) {
  throw new URIError(`The script ${oError.target.src} is not accessible.`)
}

export function htmlDecode (input) {
  const el = document.createElement('div')

  el.innerHTML = input

  return el.childNodes.length === 0 ? '' : el.childNodes[0].nodeValue
}

export function getParameterByName (name, url) {
  if (!url) { url = window.location.href }

  name = name.replace(/[[\]\\]/g, '\\$&')
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(url)

  if (!results) { return null }

  if (!results[2]) { return '' }

  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

// TODO: replace to URL standart browser API
export function parseQueryString (qstr) {
  const qIndex = qstr.indexOf('?')

  if (qIndex !== -1) { qstr = qstr.slice(qIndex + 1) }

  if (qstr.length === 0) { return {} }

  const qObj = {}
  const qArr = qstr.split('&')
  let param

  qArr.forEach(part => {
    param = part.split('=')
    qObj[decodeURIComponent(param[0])] = decodeURIComponent(param[1])
  })

  return qObj
}

export function serialize (obj) {
  return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&')
}

export function colorLuminance (hex, lum) {
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '')
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
  }

  lum = lum || 0
  // convert to decimal and change luminosity
  let rgb = '#'
  let c

  for (let i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16)
    c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16)
    rgb += (`00${c}`).substr(c.length)
  }

  return rgb
}

export function initPopupAsset (t) {
  const $t = $(t)
  const $popup = $t.find('.product-popup')
  const lib = window.lib
  const soundManager = window.soundManager
  const canMP4 = window.canMP4

  switch ($t.data('type')) {
    case 'audioBlocks':
      if (!$t.data('audid')) {
        lib.audios[`aud_${lib.audid}`] = soundManager.createSound({ url: $t.data('preview') })
        $t.data('audid', lib.audid)
        lib.audios[`aud_${lib.audid}`].play({
          whileplaying () {
            $t.find('.overlay').css('width', `${this.position / this.duration * 100}%`)
          },
        })
        lib.audid++
      } else {
        if (!lib.audios[`aud_${$t.data('audid')}`].playState) {
          lib.audios[`aud_${$t.data('audid')}`].play({
            whileplaying () {
              $t.find('.overlay').css('width', `${this.position / this.duration * 100}%`)
            },
          })
        }
      }

      break
    case 'videoBlocks':
      if (!$t.data('vidid')) {
        // $t.find('img').remove();
        const $product = $popup.find('.product')

        if (lib.awesomium) {
          const $v = $('<div class="fp" style="width: 350px; height: 260px;"></div>').prependTo($product)

          lib.videos[`vid_${lib.vidid}`] = window.flowplayer($v[0], {
            src: '/media/scripts/modules/flowplayer-3.2.18.swf',
            wmode: 'opaque',
          }, {
            clip: {
              url: $t.data('preview'),
              autoPlay: true,
              autoBuffering: true,
              scaling: 'auto',
            },
            plugins: { controls: null },
            onLoad () {
              console.warn('loaded')
            },
          })
          $t.data('vidid', lib.vidid)
          $t.addClass('inited')
          lib.videos[`vid_${lib.vidid}`].play()
          lib.vidid++
        } else {
          if ($product.find('.video-js').length) { return }

          $product.prepend(`<video class="video-js vjs-default-skin" width="350" height="260" poster="${$t.data('poster')}"></video>`)
          const opts = {}

          if (!canMP4) { opts.techOrder = ['flash'] }

          lib.videos[`vid_${lib.vidid}`] = window.videojs(t.getElementsByClassName('video-js')[0], opts, function () {
            $t.data('vidid', lib.vidid)
            lib.vidid++
            $t.addClass('inited')
            this.src([
              { type: 'video/mp4', src: $t.data('preview') },
            ])
            this.load()
            this.play()
          })
        }
      } else {
        lib.videos[`vid_${$t.data('vidid')}`].play()
      }

      break
    default:
      break
  }
}

export function initWelcomePopup () {
  const $welcomePopup = $(document).find('#tpl-welcome-popup').text()

  if (!$welcomePopup.length) { return }

  const popupUpdated = ($($welcomePopup).find('[data-update-time]').length)
    ? Number(new Date($($welcomePopup).find('[data-update-time]').data('update-time')))
    : Number(new Date(2018, 6, 16))

  if (Number(localStorage.getItem('welcomePopup')) < popupUpdated) {
    localStorage.removeItem('welcomePopup')
  }

  if (!localStorage.welcomePopup && $($welcomePopup).find('img').length) {
    const $body = $('body')

    $body.addClass('with-overlay')
    $body.append($welcomePopup)

    $('.popup-overlay, .close').on('click', e => {
      if (e.target.closest('img')) { return }

      $body.removeClass('with-overlay')
      $('.popup-overlay').remove()
      localStorage.setItem('welcomePopup', (Number(new Date())).toString())
    })
  }
}

export function combineURLParameters (url) {
  const urlParts = url.split('?')

  if (urlParts.length >= 2) {
    const pars = urlParts[1].split(/[&;]/g)

    url = urlParts[0]
    if (pars.length) {
      const obj = {}

      pars.forEach((par) => {
        const val = par.split('=')

        if (val[1] && val[1].length) {
          (obj[val[0]] = val[1])
        } else {
          obj[val[0]] && delete obj[val[0]]
        }
      })

      url += `?${serialize(obj)}`
    }

    return url
  } else {
    return url
  }
}

export function validatePhoneInput (event) {
  event = event || window.event
  if (!((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 43 || event.charCode === 45 || event.keyCode === 8)) { return false }
}
